<script>
  import EventDate from "../EventDate/EventDate.svelte";
  import EventLocation from "../EventLocation/EventLocation.svelte";
  import OnlineEventLocation from "../OnlineEventLocation/OnlineEventLocation.svelte";
  import { t, locale } from '../../i18n';
  
  export let candidateTypes;
  export let coverFileName;
  export let id;
  export let start;
  export let end;
  export let eventType;
  export let location;
  export let title;
  export let hostName;
</script>

<a class="c-event-card" href="{FRONTEND_URL}/event/{id}{$locale === 'en' ? '?lng=en': ''}" target="_blank">
  <img
    src="{IMAGE_URL}/eventCovers/{coverFileName}?w=500"
    width="315"
    alt=""
  />
  <div class="c-event-card__text">
    <ul class="c-event-card__tags">
      {#each candidateTypes as type}
        <li class="c-event-card__tag">
          {#if type === "Pupil" } {$t('pupil_tag')}   
          {:else if type === "Student" }{$t('student_tag')}  
          {:else if type === "Professional" } {$t('porfessional_tag')}  
          {/if}
      </li>
      {/each}
    </ul>
    <h3 class="c-event-card__title">{title}</h3>
    {#if hostName}
      <p class="c-event-card__host">{hostName}</p>
    {/if}
    <div class="c-event-details">
      <EventDate {start} {end} />
      {#if eventType === "Digital"}
        <OnlineEventLocation />
      {:else if location?.city}
        <EventLocation city={location.city} />
      {/if}
    </div>
  </div>
</a>

<style>
  a:link,
  a:visited {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 30px;
    border-top-left-radius: 0px;
    color: var(--colors-text);
    text-decoration: none;
    height: 100%;
    box-shadow: 8px 14px 16px 0 rgb(118 126 173 / 8%);
    transition: all 300ms ease-out;
  }

  a:hover {
    color: var(--colors-text);
    text-decoration: none;
    transform: translate(0px, -4px);
  }

  a:focus-visible {
    outline: 2px solid var(--colors-text);
  }

  img {
    aspect-ratio: 21 / 10;
    height: auto;
    width: 100%;
    object-fit: cover;
    display: block;
    background-image: var(--gradient-1);
    border-top-right-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .c-event-card{
    margin-right: 16px;
  }

  .c-event-card__text {
    padding: 20px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-height: 240px;
  }

  .c-event-card__title {
    font-size: 20px;
    font-weight: 600;
    margin-top: 24px;
    margin-bottom: 8px;
  }

  .c-event-card__host {
    color: var(--neutral-600);
    margin: 0 0 8px;
  }

  .c-event-details {
    margin-top: auto;
  }

  .c-event-card__tags {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    list-style: none;
    margin-top: -12px;
  }

  .c-event-card__tag {
    color: var(--color-text);
    background-color: var(--yellow-300);
    padding: 7px 12px;
    border-radius: 30px;
    margin-right: 8px;
    margin-top: 8px;
    margin-bottom: 0;
    margin-left: 0;
    font-size: 15px;
  }

  .c-event-card__tag:last-child {
    margin-right: 0;
  }
</style>
